import script from "./RechargePage.vue?vue&type=script&setup=true&lang=js"
export * from "./RechargePage.vue?vue&type=script&setup=true&lang=js"

import "./RechargePage.vue?vue&type=style&index=0&id=7e0bbe86&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e0bbe86"]])

export default __exports__